import { useTranslation } from 'react-i18next';

const PlaceName = props  => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();
    return t("places." + props.id);
}

export default PlaceName;